import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useNavigate } from 'react-router';

import { Course, useGetCourses } from 'api/hooks/private/courses/GetCourses';

import { PageContainer } from 'components/PageContainer';

const columns: GridColDef<Course>[] = [
  {
    field: 'title',
    type: 'string',
    headerName: 'Title',
    minWidth: 300,
  },
  {
    field: 'course_type',
    type: 'singleSelect',
    headerName: 'Type',
    minWidth: 150,
    valueOptions: [
      {
        value: 'behind_the_wheel',
        label: 'Behind The Wheel',
      },
      {
        value: 'in_person',
        label: 'In Person',
      },
      {
        value: 'synchronous_online',
        label: 'Synchronous Online',
      },
      {
        value: 'fully_online',
        label: 'Fully Online',
      },
    ],
  },
  {
    field: 'schedule_type',
    type: 'singleSelect',
    headerName: 'Schedule',
    minWidth: 150,
    valueOptions: [
      {
        value: 'self_scheduled',
        label: 'Student Scheduled',
      },
      {
        value: 'fixed',
        label: 'Fixed Schedule',
      },
      {
        value: 'manual',
        label: 'Manual Scheduling',
      },
      {
        value: 'no_schedule',
        label: 'No Schedule',
      },
    ],
  },
  {
    field: 'section_count',
    type: 'number',
    headerName: 'Section Count',
    minWidth: 150,
  },
];

export function CourseList() {
  const navigate = useNavigate();

  // fetch courses
  const courses = useGetCourses();

  return (
    <PageContainer title="Manage Courses">
      <DataGrid
        columns={columns}
        rows={courses.data}
        loading={courses.isPending}
        onRowClick={(params) => navigate(`/admin/courses/${params.row.id}`)}
      />
    </PageContainer>
  );
}

export default CourseList;
